module.exports = __webpack_public_path__ + "img/emitir-nfse.600291c2.svg";